module.exports = __webpack_public_path__ + "static/img/car_yiweike@3x.de627626.png";